module.exports = __webpack_public_path__ + "img/s8Bg10.1a2d019e.jpg";